import Phaser from 'phaser';

import {
  HERO_FRAME_WIDTH,
  HER0_FRAME_HEIGHT,
  HERO_COLUMN_LENGTH,
} from '../configs/BattlePreloader';
import AnimationKeys from '../constants/AnimationKeys';
import SceneKeys from '../constants/SceneKeys';
import TextureKeys from '../constants/TextureKeys';
import HeroList from '../mockData/HeroList';
import tileImage from '../../../assets/images/LemonLegends/tile.png';
import backgroundImage from '../../../assets/images/LemonLegends/background.jpeg';

class BattlePreloader extends Phaser.Scene {
  constructor() {
    super(SceneKeys.BattlePreloader);
  }

  preload() {
    this.load.image(TextureKeys.background, backgroundImage);
    this.load.image(TextureKeys.tile, tileImage);

    HeroList.forEach(({ name, spriteSheet }) => {
      this.load.spritesheet(name, spriteSheet, {
        frameWidth: HERO_FRAME_WIDTH,
        frameHeight: HER0_FRAME_HEIGHT,
      });
    });
  }

  create() {
    HeroList.forEach((hero) => {
      this.createHeroSpellcastAnimation(hero);
      this.createHeroThrustAnimation(hero);
      this.createHeroWalkAnimation(hero);
      this.createHeroSlashAnimation(hero);
      this.createHeroShootAnimation(hero);
      this.createHeroHurtAnimation(hero);
    });
    this.scene.start(SceneKeys.Battle);
  }

  createHeroSpellcastAnimation({ id, name }) {
    this.anims.create({
      key: `${AnimationKeys.HeroSpellcastLeft}-${id}`,
      frames: this.anims.generateFrameNumbers(name, {
        start: HERO_COLUMN_LENGTH * 1,
        end: HERO_COLUMN_LENGTH * 1 + 6,
      }),
      frameRate: 10,
      repeat: 0,
    });

    this.anims.create({
      key: `${AnimationKeys.HeroSpellcastRight}-${id}`,
      frames: this.anims.generateFrameNumbers(name, {
        start: HERO_COLUMN_LENGTH * 3,
        end: HERO_COLUMN_LENGTH * 3 + 6,
      }),
      frameRate: 10,
      repeat: 0,
    });
  }

  createHeroThrustAnimation({ id, name }) {
    this.anims.create({
      key: `${AnimationKeys.HeroThrustLeft}-${id}`,
      frames: this.anims.generateFrameNumbers(name, {
        start: HERO_COLUMN_LENGTH * 5,
        end: HERO_COLUMN_LENGTH * 5 + 7,
      }),
      frameRate: 10,
      repeat: 0,
    });

    this.anims.create({
      key: `${AnimationKeys.HeroThrustRight}-${id}`,
      frames: this.anims.generateFrameNumbers(name, {
        start: HERO_COLUMN_LENGTH * 7,
        end: HERO_COLUMN_LENGTH * 7 + 7,
      }),
      frameRate: 10,
      repeat: 0,
    });
  }

  createHeroWalkAnimation({ id, name }) {
    this.anims.create({
      key: `${AnimationKeys.HeroWalkLeft}-${id}`,
      frames: this.anims.generateFrameNumbers(name, {
        start: HERO_COLUMN_LENGTH * 9,
        end: HERO_COLUMN_LENGTH * 9 + 8,
      }),
      frameRate: 10,
      repeat: -1,
    });

    this.anims.create({
      key: `${AnimationKeys.HeroWalkRight}-${id}`,
      frames: this.anims.generateFrameNumbers(name, {
        start: HERO_COLUMN_LENGTH * 11,
        end: HERO_COLUMN_LENGTH * 11 + 8,
      }),
      frameRate: 10,
      repeat: -1,
    });
  }

  createHeroSlashAnimation({ id, name }) {
    this.anims.create({
      key: `${AnimationKeys.HeroSlashLeft}-${id}`,
      frames: this.anims.generateFrameNumbers(name, {
        start: HERO_COLUMN_LENGTH * 13,
        end: HERO_COLUMN_LENGTH * 13 + 5,
      }),
      frameRate: 10,
      repeat: 0,
    });

    this.anims.create({
      key: `${AnimationKeys.HeroSlashRight}-${id}`,
      frames: this.anims.generateFrameNumbers(name, {
        start: HERO_COLUMN_LENGTH * 15,
        end: HERO_COLUMN_LENGTH * 15 + 5,
      }),
      frameRate: 10,
      repeat: 0,
    });
  }

  createHeroShootAnimation({ id, name }) {
    this.anims.create({
      key: `${AnimationKeys.HeroShootLeft}-${id}`,
      frames: this.anims.generateFrameNumbers(name, {
        start: HERO_COLUMN_LENGTH * 17,
        end: HERO_COLUMN_LENGTH * 17 + 12,
      }),
      frameRate: 10,
      repeat: 0,
    });

    this.anims.create({
      key: `${AnimationKeys.HeroShootRight}-${id}`,
      frames: this.anims.generateFrameNumbers(name, {
        start: HERO_COLUMN_LENGTH * 19,
        end: HERO_COLUMN_LENGTH * 19 + 12,
      }),
      frameRate: 10,
      repeat: 0,
    });
  }

  createHeroHurtAnimation({ id, name }) {
    this.anims.create({
      key: `${AnimationKeys.HeroHurt}-${id}`,
      frames: this.anims.generateFrameNumbers(name, {
        start: HERO_COLUMN_LENGTH * 20,
        end: HERO_COLUMN_LENGTH * 20 + 5,
      }),
      frameRate: 10,
      repeat: 0,
    });
  }
}

export default BattlePreloader;
